export const TIPO_COLETA = {
  1: "Entrada",
  2: "Aferição",
  3: "Saída",
};


export const resolveTranlationTipoColeta = (t, idTipoColeta) => {
  switch (idTipoColeta) {
    case 1:
      return t("statusIndicator:entry");
    case 2:
      return t("statusIndicator:measurement");
    case 3:
      return t("statusIndicator:exit");
    default:
      return t("statusIndicator:unknown-type");
  }
};

export const TIPO_MOVIMENTACAO = {
  CREATION: 1,
  REMOVAL: 2,
  PURCHASE: 3,
  SALE: 4,
  ADJUSTMENT: 5,
  TRANSFER: 6,
  MOVEMENT_BETWEEN_PASTURES: 7,
  CATEGORY_CHANGE: 8,
  POSITIVE_INTERFUSION: 9, // ENTREVERO POSITIVO
  NEGATIVE_INTERFUSION: 10, // ENTREVERO NEGATIVO
  DEATH: 13,
  BIRTH: 14,
  INDETERMINATE: 999,
};
